import React, { useState } from 'react';

// Collapsible section with a persisted open/closed state. Shares the Forecast
// page's section styling (cs-fc-section …) so it looks identical wherever it's
// reused (Forecast top row, Swell Map globe, etc.). Extracted from the inline
// Section component in pages/Forecast.js.
export default function Collapsible({ id, title, sub, defaultOpen = true, right, className = '', children }) {
  const storeKey = `cs-fc-sec-${id}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = localStorage.getItem(storeKey);
      return v == null ? defaultOpen : v === '1';
    } catch {
      return defaultOpen;
    }
  });
  const toggle = () =>
    setOpen((o) => {
      try {
        localStorage.setItem(storeKey, !o ? '1' : '0');
      } catch {
        /* ignore */
      }
      return !o;
    });
  return (
    <section className={`cs-fc-section ${open ? 'is-open' : 'is-closed'} ${className}`}>
      <div className="cs-fc-sechead">
        <button className="cs-fc-sectoggle" onClick={toggle} aria-expanded={open}>
          <span className="cs-fc-secchev">{open ? '▾' : '▸'}</span>
          <h2>{title}</h2>
          {sub && <span className="cs-fc-secsub">{sub}</span>}
        </button>
        {right && <div className="cs-fc-secright">{right}</div>}
      </div>
      {open && <div className="cs-fc-secbody">{children}</div>}
    </section>
  );
}
